import {useContext, useEffect} from 'react';

import {ACTION_VIEW} from '../../data/constants/data-collection-actions';
import {CollectContext} from './CollectContextProvider';
import {useEvent} from '../../data/hooks/eventHooks';
import {useParams} from 'react-router';

/**
 * Adds data collection point when contents are first rendered
 */
const CollectRender = props => {
    const {children, action = 'view', objectType = null, objectId = null, objectDetail = null} = props,
        {eventId} = useParams(),
        event = useEvent(eventId),
        context = useContext(CollectContext);

    useEffect(() => {
        app.store.dispatch(app.actions.collect.event(ACTION_VIEW, event?.id, objectType, objectId, objectDetail, context));
    }, [objectType, objectId, objectDetail, context]);

    return children || null;
};

export default CollectRender;
